import React from "react";
import { Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const FormikLabel = ({ text = "label", required = false, ...props }) => {
  const theme = useTheme();

  return (
    <Typography
      variant="subtitle1"
      component="label"
      {...props}
      sx={{
        ...props.sx,
        fontWeight: theme.typography.fontWeightBold,
        marginBottom: theme.spacing(0.5),
        display: "block",
        fontSize: theme.typography.fontSize,
        fontFamily: theme.typography.fontFamily,
        color: theme.palette.text.primary,
      }}
    >
      {text}
      {required && <span style={{ color: theme.palette.error.main }}> *</span>}
    </Typography>
  );
};

export default FormikLabel;
